import React from "react";
import {Link} from "../../../../../../../router";
import {LINK_DASHBOARD} from "../../../../../../../constants/links";

import LogoutBtn from "../../../../helpers/LogoutBtn";

export default () => {
  const referralPanelLink = <Link href={LINK_DASHBOARD}>Merchant Panel</Link>;
  const divider = {divider: true};
  const accLogoutBtn = <LogoutBtn />;

  return (
    [
      referralPanelLink,
      divider,
      accLogoutBtn
    ]
  );
}
